import React, { useCallback, useEffect } from 'react';

type OwnProps = React.PropsWithChildren<{
  onEscape: (_?: any) => void;
}>;

const OnEscapeListener = ({ children, onEscape }: OwnProps) => {
  const onEscapeListener = useCallback(
    ({ key }: KeyboardEvent) => {
      if (key === 'Escape') onEscape();
    },
    [onEscape]
  );

  useEffect(() => {
    document.addEventListener('keyup', onEscapeListener);

    return () => {
      document.removeEventListener('keyup', onEscapeListener);
    };
  }, [onEscapeListener]);

  return <>{children}</>;
};

export default OnEscapeListener;
